import { useState } from "react";
import { BsGithub } from "react-icons/bs";
import { CgWebsite, CgAppleWatch  } from "react-icons/cg";
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";

function ProjectCards(props) {
  const [open, setOpen] = useState(false);

  const handleButtonClick = (url, e) => {
    e.stopPropagation();
    window.open(url, "_blank", "noopener,noreferrer");
  };

  return (
    <>
      <div className="approach-item project-card">
        <div 
          className="project-image-container" 
          onClick={() => setOpen(true)}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => e.key === 'Enter' && setOpen(true)}
        >
          <img src={props.imgPath} alt="card-img" className="project-image" />
          <div className="image-overlay">
            <span>Click to enlarge</span>
          </div>
        </div>
        <h3 className="purple">{props.title}</h3>
        <p>{props.description}</p>
        <div className="project-buttons">
          <button 
            onClick={(e) => handleButtonClick(props.ghLink, e)}
            className="project-link-button"
            type="button"
          >
            <BsGithub /> GitHub
          </button>

          {!props.isBlog && props.webLink && (
            <button
              onClick={(e) => handleButtonClick(props.webLink, e)}
              className="project-link-button"
              type="button"
            >
              <CgWebsite /> Website
            </button>
          )}

          {!props.isBlog && props.demoLink && (
            <button
              onClick={(e) => handleButtonClick(props.demoLink, e)}
              className="project-link-button"
              type="button"
            >
              <CgAppleWatch /> Demo
            </button>
          )}
        </div>
      </div>

      <Lightbox
        open={open}
        close={() => setOpen(false)}
        slides={[{ src: props.imgPath }]}
        carousel={{ finite: true }}
        animation={{ fade: 400 }}
        controller={{ closeOnBackdropClick: true }}
        styles={{ 
          container: { backgroundColor: "rgba(17, 16, 34, 0.95)" },
          button: { 
            filter: "invert(1) brightness(150%)",
            color: "var(--imp-text-color)",
          }
        }}
      />
    </>
  );
}

export default ProjectCards;
